"use client";

import { useTranslations } from "next-intl";
import { ResponsiveModal } from "@/components/features/staking/ResponsiveModal";
import { useRouter } from "@/i18n/navigation";

interface CandidacySuccessModalProps {
  open: boolean;
}

/**
 * Success modal shown after candidacy registration (SA-1 rewrite per Figma 5462:52455).
 * SA-2: mounted on /info/dao page when ?just_registered=1 query param present.
 * NO dismiss button per Figma walk.
 * Close = backdrop / X / Esc → router.replace("/info/dao") strips flash flag (AC-1.NEW.13).
 */
export const CandidacySuccessModal: React.FC<CandidacySuccessModalProps> = ({
  open,
}) => {
  const t = useTranslations("dao");
  const router = useRouter();

  const handleClose = () => {
    // AC-1.NEW.13: one-shot consumption — replace strips ?just_registered=1
    router.replace("/info/dao");
  };

  return (
    <ResponsiveModal
      open={open}
      onOpenChange={(v) => {
        if (!v) handleClose();
      }}
      title={t("election.beCandidate.successTitle")}
      desktopMaxWidth="md"
    >
      <div className="bg-bg-secondary border border-stroke-subtle rounded-lg shadow-[0px_20px_24px_-4px_rgba(177,197,229,0.1),0px_8px_8px_-4px_rgba(189,205,230,0.04)] flex flex-col items-center px-8 py-5 gap-4">
        {/* Heading — 2 lines per Figma 5462:52455 */}
        <p className="text-base font-semibold text-foreground text-center leading-[1.4]">
          {t("election.beCandidate.successHeading")}
        </p>
        {/* Note: double-space between دائو and شدید is verbatim per Figma spec — DO NOT fix */}
        <p className="text-base font-semibold text-foreground text-center leading-[1.4]">
          {t("election.beCandidate.successSubheading")}
        </p>

        {/* Body — 2 lines per Figma 5462:52455 */}
        {/* Note: leading space + double-space verbatim per spec */}
        <p className="text-xs font-medium text-text-secondary text-center leading-[1.4]">
          {t("election.beCandidate.successBody")}
        </p>
        <p className="text-xs font-medium text-text-secondary text-center leading-[1.4]">
          {t("election.beCandidate.successFooter")}
        </p>
      </div>
    </ResponsiveModal>
  );
};
